// SubscriptionExpiredPage.jsx
import React, { useEffect } from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { logEvent } from '../../utils/analytics';
import { useAuth } from '../auth/AuthContext';
import './SubscriptionExpiredPage.css';

const SubscriptionExpiredPage = () => {
  const { user, isAuthenticated, loading, login } = useAuth();
  const navigate = useNavigate();
  
  // 設置頁面標題
  useEffect(() => {
    logEvent('auth_gate_view', { status: 'expired' });
  }, []);

  useEffect(() => {
    document.title = '訂閱已過期';
  }, []);

  // 檢查用戶狀態並進行重定向
  useEffect(() => {
    // 當用戶資料加載完成後檢查
    if (!loading) {
      // 如果用戶已登入且未過期，則返回首頁
      if (isAuthenticated && user && 
          (user.expireDate === 'permanent' || !user.isExpired)) {
        navigate('/');
      }
    }
  }, [loading, isAuthenticated, user, navigate]);

  // 載入中顯示載入動畫
  if (loading) {
    return (
      <Container className="my-5 pt-5 text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">載入中...</span>
        </div>
        <p className="mt-3">載入中，請稍候...</p>
      </Container>
    );
  }

  // 聯絡客服的點擊處理函數 - 統一使用 admin@nogi46.me
  const handleContactSupport = () => {
    window.open('mailto:admin@nogi46.me', '_blank');
  };

  // 點擊登入或續訂按鈕的處理函數
  const handleActionClick = () => {
    if (!isAuthenticated) {
      // 未登入時，直接觸發 SSO 登入
      login();
    } else {
      // 已登入時，打開郵件向管理員發送續訂請求
      window.open('mailto:admin@nogi46.me?subject=訂閱續訂請求&body=您好，我想續訂會員服務。%0A%0A我的用戶名：' +
        (user ? user.username : '') +
        '%0A用戶ID：' +
        (user ? user.id : '') +
        '%0A%0A請問如何進行續訂流程？%0A%0A謝謝！', '_blank');
    }
  };

  return (
    <div className="subscription-expired-container">
      <div className="subscription-expired-content">
        <div className="subscription-expired-header">
          <h2>訂閱已過期</h2>
        </div>
        
        <div className="subscription-expired-body">
          <Alert variant="warning" className="mb-4">
            <Alert.Heading>您的訂閱服務已經過期</Alert.Heading>
            {isAuthenticated && user?.expireDate ? (
              <p>
                您的訂閱已於 {new Date(user.expireDate).toLocaleDateString('zh-TW', {year: 'numeric', month: 'long', day: 'numeric'})} 過期，
                為了能夠繼續使用所有功能，請續訂您的服務。
              </p>
            ) : (
              <p>
                您的訂閱已過期或您尚未登入系統。為了能夠繼續使用所有功能，請登入並續訂您的服務。
              </p>
            )}
            <hr />
            <p className="mb-0">
              如有疑問或需要協助，請隨時與我們的客服團隊聯絡：<a href="mailto:admin@nogi46.me">admin@nogi46.me</a>
            </p>
          </Alert>

          <div className="subscription-expired-animation">
            <div className="animation-wrapper">
              <img 
                src="/images/gif/kaki.gif"
                alt="訂閱已過期"
                className="expired-gif"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/avatar/乃木坂46.jpg";
                }}
              />
            </div>
            <p className="animation-caption">續訂後即可繼續享受完整服務...</p>
          </div>

          <div className="subscription-actions">
            <Button 
              variant="primary" 
              size="lg" 
              onClick={handleActionClick}
            >
              {isAuthenticated ? '立即續訂' : '請先登入'}
            </Button>
            <Button variant="outline-secondary" size="lg" onClick={handleContactSupport}>
              聯絡客服
            </Button>
          </div>

          <div className="text-center mt-4">
            <Button variant="link" onClick={() => navigate('/')}>
              返回首頁
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpiredPage;